/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import LocalDate from '../../domain/type/Date'

const _MonthlyClosingHeadState = {
  id: null,
  monthly_close_date: null,
  hotel_id: null,
  hotel_name: null,
  status: null,
  rsvn_sales: 0,
  ota_comsn: 0,
  rsvn_pay_comsn: 0,
  sales: 0,
  variable_costs: 0,
  fixed_costs: 0,
  variable_expenses: 0,
  fixed_expenses: 0,
  accom_tax: 0,
  accom_pay_comsn: 0,
  management_comsn: 0,
  memo: '',
  daily_closing_count: null,
  occupancy_dates: 0
}

class MonthlyClosingHeadState extends Record(_MonthlyClosingHeadState) {
  mergeModel(model) {
    if (model) {
      const monthly_close_date = model.monthly_close_date
      if (monthly_close_date) {
        model['monthly_close_date'] = new LocalDate(monthly_close_date)
      }
      return this.merge(model)
    }

    return this
  }

  toRequestBody() {
    const monthly_close_date = this.monthly_close_date ? this.monthly_close_date.toISODate() : null
    return {
      id: this.id,
      monthly_close_date: monthly_close_date,
      hotel_id: this.hotel_id,
      status: this.status,
      management_comsn: this.management_comsn,
      memo: this.memo
    }
  }
}

export { MonthlyClosingHeadState }
